import React, {useState} from 'react';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, ScrollView, Dimensions, Image } from 'react-native';
// import * as RootNavigation from '../../../root.navigation.js';


const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;


// const PlusIcon = (props) => (
//   <Icon {...props} name='plus-square-outline' />
// );
export const ProfileScreen = () => {


  return (
    <ScrollView>
      <Layout style={styles.container} level='2' >

        <Text appearance='hint' style={{margin:40, textAlign:'center', lineHeight:25}}>تست</Text>

      </Layout>
      </ScrollView>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    alignItems:'center',
    justifyContent:'space-between',
    paddingBottom:25,
    height: height-30


  },
});
// <Image source= {require('../../../assets/new_invoice.png')} style={{width:width*0.7, height:width*0.7, marginVertical:25}} />
